/* EP - nuotrauku apsauga. 2026-09-11
   Blokuoja desini pelės mygtuka ir vilkima TIK ant nuotrauku.
   Tekstas, nuorodos, formos ir likusi svetaine veikia iprastai.
   Ikeliamas is snippets/stylesheets.liquid - ten ir isjungiama. */

(function () {
  var SEL = 'img, picture, svg.placeholder-svg, .product-media, .media, .card-gallery, .zoom-dialog';

  function onImage(target) {
    return !!(target && target.closest && target.closest(SEL));
  }

  document.addEventListener(
    'contextmenu',
    function (event) {
      if (onImage(event.target)) event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (event) {
      if (onImage(event.target)) event.preventDefault();
    },
    true
  );

  /* iOS ilgo paspaudimo meniu (Save Image / Search with Google) */
  var style = document.createElement('style');
  style.textContent = 'img, picture { -webkit-touch-callout: none; }';
  document.head.appendChild(style);
})();
